import globalEnvironment from './global.environment';

export const environment = {
    ...globalEnvironment,

    NODE_ENV: 'production',

    apiUrl: 'https://api.box8.co.in',
    accountsApiUrl: 'https://accounts.box8.co.in',
    catalogUrl: 'https://api.box8.in',
    assetsUrl: 'https://assets.box8.co.in',
    webApiUrl: 'https://ssr.box8.in',
    c3pServiceUrl: 'https://cart.box8.co.in',

    platform: 'web',

    app_link: {
        google: 'https://play.google.com/store/apps/details?id=com.poncho.eatclub&hl=en_IN&gl=US',
        apple: 'https://apps.apple.com/us/app/eatclub-order-food-online/id1535583068'
    },

    payments: {
        paytmUrl: 'https://secure.paytmpayments.com/'
    },

    sentryDsn: 'https://5f0a610e12794467a5ea2cc1f9159442@sentry.io/1362239',

    redis_db: {
        host: 'box8-accounts.kseb3c.0001.aps1.cache.amazonaws.com',
        port: 6379,
        db: 3
    },

    DEBUG: false,

    VERSION: require('../../package.json').version
};
